<script setup>
    import { computed, ref, defineProps, onMounted, onBeforeUnmount } from 'vue';
    // ----------------------------
    // Props
    // ----------------------------
    const props = defineProps({
        buttonTop: {
            type: Number,
            default: null,
        },
        buttonLeft: {
            type: Number,
            default: null,
        },
        divLeft: {
            type: Number,
            default: null,
        },
        divTop: {
            type: Number,
            default: null,
        },
        divBottom: {
            type: Number,
            default: null,
        },
        divWidth: {
            type: Number,
            default: null,
        },
        classTop: {
            type: String,
            default: '',
        },
    });
    // ----------------------------
    // リアクティブ変数
    // ----------------------------
    const showTooltip = ref(false);
    const tooltip = ref()

    // ----------------------------
    // 関数
    // ----------------------------
    // ツールチップ関数
    const toggleTooltip = () => {
        showTooltip.value = !showTooltip.value;
    };
    // ----------------------------
    // 算術プロパティ
    // ----------------------------
    const isTooltipVisible = computed(() => {
        return showTooltip.value;
    });

    function handleClickOutside(event) {
        if (tooltip.value && !tooltip.value.contains(event.target)) {
            showTooltip.value = false
        }
    }
    onMounted(() => {
        document.addEventListener('click', handleClickOutside)
    })

    onBeforeUnmount(() => {
        document.addEventListener('click', handleClickOutside)
    })
</script>

<template>
    <button type="button" class="statusInfoTooltip" @click="toggleTooltip" ref="tooltip" :style="{ top: props.buttonTop + 'px',left: props.buttonLeft + 'px' }">&nbsp;</button>
    <div v-show="isTooltipVisible" :class="['statusInfo', props.classTop]" :style="{ top: props.divTop + 'px', left: props.divLeft + 'px', width: props.divWidth + 'px'}">
        <slot />
    </div>
</template>

<style scoped>
.statusInfo.top::before {
    top: -12px !important;
    left: 12px !important;
  }
  /* .statusInfo {
    display: block;
  } */
</style>
